
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as adminxa8pv_55Te8NRanW8bWnhTBxM9ViIooCMRUtfjyK6xsMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/sitemap/sitemap-front/app/pages/admin.vue?macro=true";
import { default as indexwfbgR4EkwWhYWPdlvCH9xm2kzk2n_QjYxbZcSeqjiRUMeta } from "/tmpfs/builds/maltcommunity/malt/apps/malt/sitemap/sitemap-front/app/pages/index.vue?macro=true";
export default [
  {
    name: "admin",
    path: "/admin",
    meta: { ...(adminxa8pv_55Te8NRanW8bWnhTBxM9ViIooCMRUtfjyK6xsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/sitemap/sitemap-front/app/pages/admin.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmpfs/builds/maltcommunity/malt/apps/malt/sitemap/sitemap-front/app/pages/index.vue")
  }
]